//PrimeReact
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"

//Appointments utils
import { formatOrgCalDate } from "./utils"

export default function AppointmentsTablePending({
  pendingAppointments,
  getParticipantColumnBody,
  getPendingActionsColumnBody,
}) {
  return (
    <DataTable
      value={pendingAppointments}
      style={{ marginLeft: "-40px" }}
      sortField="startDateTime"
      sortOrder={1}
    >
      <Column
        field="startDateTime"
        sortable
        header="Date"
        body={formatOrgCalDate}
      />
      <Column field="engagementType" sortable header="Engagement Type" />
      <Column
        field="engagementChannel"
        sortable
        bodyStyle={{ textTransform: "capitalize" }}
        header="Engagement Channel"
        body={(rowData) => {
          if (rowData.cron == null) {
            return rowData.engagementChannel
          } else {
            return rowData.engagementChannel + " | Recurring"
          }
        }}
      />
      <Column field="scheduledTime" sortable header="Scheduled Time" />
      {!!getParticipantColumnBody ? (
        <Column
          body={getParticipantColumnBody}
          field="participantName"
          sortable
          header="Participant"
        />
      ) : null}

      <Column field="type" sortable header="Type" />
      <Column
        field="action"
        header="Action"
        body={getPendingActionsColumnBody}
      />
    </DataTable>
  )
}
